import React from "react";
import {Modal, Button} from 'react-bootstrap';
import Login from '../LandingPage/Login';
import {useHistory} from 'react-router-dom'
import axios from 'axios';
const LoginByModal=(props)=>{
    let history=useHistory()
    if(props.loginClick){
        return(
            <Modal show={props.loginClick} onHide={()=>{
                props.closeModal()
            }} style={{
                padding:0,
                margin:0,
                display:'block'
            }}>
                <Modal.Header closeButton>
                    <Modal.Title></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Login login_not={props.login_not} propsStateData={props.propsStateData} closeModalIfLogiIn={(ev)=>{
                        axios.get('/currentuser')
                        .then(res=>{
                            if(res.data.error){

                            }else{                              
                                props.closeModal()
                                history.replace({ pathname: '/raiserequests',props:res.data})
                            }
                        })
                    }}/>
                </Modal.Body>
                <Modal.Footer>
        </Modal.Footer>
            </Modal>
        )
    }
    else{
        return <></>
    }
}
export default LoginByModal;